import axios from "axios";
import { doc, getDoc, getFirestore, setDoc } from "firebase/firestore";
import React from "react";

/**
 * this is the function that calls the api. all other functions in this file calls it
 *
 * @param {string} url the endpoint to go to
 * @param {string} method the method to use (get,post,delete,put...)
 * @param {Object} body if it is a post - what is the body
 * @param {Object} params params for axios get
 * @returns {Object}
 */
async function queryAPI(url, method, body, params) {
  let headers;
  const token = localStorage.getItem("userJWT");
  if (token) {
    headers = { authorization: token };
  }

  try {
    const response = await axios({
      url: process.env.REACT_APP_API_URL + url,
      method,
      data: body,
      params,
      headers,
    });
    return response;
  } catch (err) {
    return { err };
  }
}

/** @typedef {object} UserData
 * @property {number} status
 * @property {object} data
 * @property {object[]} data.Accounts_list
 * @property {string} data.Accounts_list.Account_id
 * @property {string} data.Accounts_list.Account_name_ENG
 * @property {string} data.Accounts_list.Account_name_HEB
 * @property {string} data.Accounts_list.Content_id
 * @property {string} data.Accounts_list.Content_name_ENG
 * @property {string} data.Accounts_list.Content_name_HEB
 * @property {number} data.Cumulative_yield
 * @property {string} data.PrimContact
 * @property {string} data.PrimContactENG
 * @property {string} data.account_id
 * @property {string} data.account_number
 * @property {string} data.balance
 * @property {object[]} data.cash_transactions
 * @property {string} data.cash_transactions.action
 * @property {string} data.cash_transactions.box
 * @property {number} data.cash_transactions.calculated_sum
 * @property {number} data.cash_transactions.credit
 * @property {string} data.cash_transactions.date
 * @property {number} data.cash_transactions.debit
 * @property {string} data.cash_transactions.name
 * @property {number} data.cash_transactions.sum
 * @property {string} data.cash_transactions.translate_eng
 * @property {string} data.cash_transactions.translate_heb
 * @property {object[]} data.deposits
 * @property {number} data.deposits.USD_amount
 * @property {number} data.deposits.amount
 * @property {string} data.deposits.id
 * @property {string} data.deposits.type
 * @property {string} data.email
 * @property {string} data.firstName
 * @property {string} data.firstNameENG
 * @property {object[]} data.grants
 * @property {string|null} data.grants.Comments
 * @property {string|null} data.grants.DonationGoal
 * @property {string|null} data.grants.DonationGoal_select
 * @property {number|null} data.grants.amount
 * @property {null|number} data.grants.amount_USD
 * @property {string[]|} data.grants.category
 * @property {string[]|} data.grants.categoryENG
 * @property {string} data.grants.currency
 * @property {string|null} data.grants.grant_acknowledgement
 * @property {string} data.grants.id
 * @property {string} data.grants.name
 * @property {object} data.grants.ngo
 * @property {string} data.grants.ngo.AmutaContact
 * @property {string} data.grants.ngo.NgoNumber
 * @property {string} data.grants.ngo.about
 * @property {string} data.grants.ngo.aboutENG
 * @property {|string[]} data.grants.ngo.classification
 * @property {string[]} data.grants.ngo.classificationENG
 * @property {string[]} data.grants.ngo.district
 * @property {string[]} data.grants.ngo.districtENG
 * @property {number} data.grants.ngo.employees
 * @property {string} data.grants.ngo.eng_name
 * @property {null|string} data.grants.ngo.foundyear
 * @property {number} data.grants.ngo.havriAmuta
 * @property {boolean} data.grants.ngo.keshetApprove
 * @property {string} data.grants.ngo.keshet_id
 * @property {string|null} data.grants.ngo.mainactivity
 * @property {string|null} data.grants.ngo.mainactivityENG
 * @property {string} data.grants.ngo.name
 * @property {boolean} data.grants.ngo.nihulTakin
 * @property {number} data.grants.ngo.numberOfDonors
 * @property {number|null} data.grants.ngo.number_of_keshet_donors
 * @property {number} data.grants.ngo.rate
 * @property {boolean} data.grants.ngo.saif46
 * @property {number|null} data.grants.ngo.status
 * @property {boolean} data.grants.ngo.tavMidot
 * @property {null|string} data.grants.ngo.type
 * @property {number} data.grants.ngo.volunteers
 * @property {string} data.grants.ngo.website
 * @property {string} data.grants.ngo_number
 * @property {string} data.grants.pass_date
 * @property {string} data.grants.request_date
 * @property {string} data.grants.status
 * @property {object[]} data.grants_sum_by_year
 * @property {number} data.grants_sum_by_year.sum
 * @property {string} data.grants_sum_by_year.year
 * @property {array[]|string[]|number[]|null[]|number[]} data.grants_sum_table
 * @property {array[]|string[]|number[]|null[]|number[]} data.grants_sum_table_ENG
 * @property {string} data.id9
 * @property {object} data.invests
 * @property {number} data.invests.ForeignExchange_percents
 * @property {number} data.invests.cash_percents
 * @property {number} data.invests.corbonds_percents
 * @property {number} data.invests.cumulative_yield
 * @property {number} data.invests.govbond_percents
 * @property {number} data.invests.stock_percents
 * @property {object[]} data.invests.yield_year_percent
 * @property {string} data.invests.yield_year_percent.period
 * @property {number} data.invests.yield_year_percent.present
 * @property {string} data.keshet_id
 * @property {string} data.keshetname
 * @property {string} data.lastName
 * @property {string} data.lastNameENG
 * @property {object[]} data.managed_trnsaction
 * @property {string} data.managed_trnsaction.action
 * @property {string} data.managed_trnsaction.box
 * @property {number} data.managed_trnsaction.calculated_sum
 * @property {number} data.managed_trnsaction.credit
 * @property {string} data.managed_trnsaction.date
 * @property {number} data.managed_trnsaction.debit
 * @property {string} data.managed_trnsaction.name
 * @property {number} data.managed_trnsaction.sum
 * @property {string} data.managed_trnsaction.translate_eng
 * @property {string} data.managed_trnsaction.translate_heb
 * @property {string} data.mobile_phone
 * @property {} data.new_grants
 * @property {} data.notifications
 * @property {string} data.record_type_id
 * @property {object[]} data.requests
 * @property {string|null} data.requests.Comment
 * @property {string} data.requests.CreatedDate
 * @property {string} data.requests.Status
 * @property {string} data.requests.Subject
 * @property {number|null} data.requests.amount
 * @property {null|string} data.requests.contactMail
 * @property {null|string} data.requests.contactName
 * @property {string|null} data.requests.contactNotes
 * @property {null|string} data.requests.contactPhone
 * @property {null|string} data.requests.details
 * @property {string|null} data.requests.grantGoal
 * @property {string|null} data.requests.grant_acknowledgement
 * @property {string|null} data.requests.grant_curr
 * @property {string} data.requests.id
 * @property {string|null} data.requests.org
 * @property {null|string} data.requests.orgENG
 * @property {string|null} data.requests.orgHeb
 * @property {string|null} data.requests.otherGoal
 * @property {null|string} data.requests.programName
 * @property {string} data.requests.request
 * @property {number} data.rest_nis
 * @property {string} data.secondContact
 * @property {string} data.secondContactENG
 * @property {number} data.total_balance
 * @property {number} data.total_cash
 * @property {number} data.total_future_grant
 * @property {number} data.total_grant
 * @property {number} data.total_manage
 * @property {string} data.username
 * @property {string} data.usrimg
 */

/**
 *
 * @returns {Promise<UserData>}
 */

export async function getUserData() {
  const res = await queryAPI("/salesforce/user");
  return res;
}

/** @typedef {array} UserAccount
 * @property {object} 0
 * @property {object} 1
 * @property {string} 0.Content_id
 * @property {string} 0.Account_id
 * @property {string} 0.Account_name_HEB
 * @property {string} 0.Account_name_ENG
 * @property {string} 0.Content_name_HEB
 * @property {string} 0.Content_name_ENG
 * @property {string} 1.Content_id
 * @property {string} 1.Account_id
 * @property {string} 1.Account_name_HEB
 * @property {string} 1.Account_name_ENG
 * @property {string} 1.Content_name_HEB
 * @property {string} 1.Content_name_ENG
 */

/**
 *
 * @returns {Promise<UserAccount>}
 */
export async function getUserAccounts() {
  const res = await queryAPI("/salesforce/user/get-accounts");
  return res;
}

export async function isPhoneInDB(phone) {
  const res = await queryAPI("/salesforce/phone-check?phone=" + phone);
  return res;
}

export async function sendIsraelSmsVerification(phone) {
    const res = await queryAPI("/auth/send_verification_sms", "post", {
        phone_number: phone,
    });
    console.log(phone, res);
    return res;
}

export async function sendIsraelSmsCodeVerification(phone, code) {
    const res = await queryAPI("/auth/verify_verification_code", "post", {
        phone_number: phone,
        code: code,
    });
    return res;
}

export async function getUserFiles(account_number) {
  const res = await queryAPI("/firebase/storage/" + account_number);
  return res;
}

export async function getNotificationFiles() {
  const res = await queryAPI("/firebase/notifications");
  return res;
}

let session_id = "";
export async function chatWithBot(question) {
  const payload = { question };

  if (session_id) {
    payload.session_id = session_id;
  }
  const res = await queryAPI("/chat", "POST", payload);
  if (
    (!session_id && res.data.session_id) ||
    session_id !== res.data.session_id
  ) {
    session_id = res.data.session_id;
  }
  return res;
}
/**
 * POST new donation request
 *
 */

export async function openNewDonation(formData) {
  delete formData.founder;
  delete formData.checkNotAnon;
  delete formData.contactDetails;

  const res = await queryAPI("/salesforce/open-ticket", "POST", formData);
  console.log(res);
  return res;
}

/**
 * Open new ticket from Actions screen
 *
 */
export async function openNewTicket(formData) {
  const res = await queryAPI("/salesforce/open-ticket", "POST", formData);
  console.log(res);
  return res;
}

/**
 * get the list of Ngos
 *
 */
export async function getNgos(page) {
  const response = await queryAPI("/salesforce/ngo?page=" + page, "get");

  return response;
}

/**
 * get the list of Unread Notifications
 *
 */
export async function getNotifications() {
  const response = await queryAPI("/notifications?unread_status=true", "get");
  return response;
}

/**
 * get the count of unread Notifications
 *
 */
export async function getUnreadNotificationsCount() {
  const response = await queryAPI(
    "/notifications/count?unread_status=true",
    "get"
  );
  return response;
}

/**
 * put unread Notifications as read
 *
 */
export async function putNotificationsStatus(id) {
  const response = await queryAPI("/notifications" + id, "put", {
    unread_status: false,
  });
  return response;
}

/**
 * put read Notifications as unread (for testing only)
 *
 */
export async function resetNotifications(id) {
  const response = await queryAPI("/notifications" + id, "put", {
    unread_status: true,
  });
  return response;
}

/**
 * get the list of Requests
 *
 */
export async function getRequests() {
  const response = await queryAPI("/salesforce/requests", "get");
  return response;
}

/**
 * get the list of Grants history
 *
 */
export async function getGrants() {
  const response = await queryAPI("/new-grants", "get");
  return response;
}

/**
 * post ngo rating and feedback
 *
 */
export async function postFeedback(ngoId, userRating, userFeedback) {
  const response = await queryAPI("/salesforce/ratengo", "post", {
    ngo: ngoId,
    newRating: userRating,
    newFeedback: userFeedback,
  });
  return response;
}

/**
 * post new grant request
 *
 */
export async function postNewGrant(newGrantData) {
  const response = await queryAPI(
    "/salesforce/new-grants",
    "post",
    newGrantData
  );
  return response;
}

/**
 * this is a function to post a new request
 *
 * @param {Object} form a form with 3 keys: request, department, details
 * @returns {Promise<*|{err: *}>}
 */
export async function sendNewRequest(form) {
  const data = await queryAPI("/salesforce/newrequest", "post", form);
  console.log(data);
  if (data.status === 200) {
    return data;
  } else {
    console.log("server is shitty");
  }
}

/**
 * get the list of districts
 *
 */

export async function getDistrictData() {
  const res = await queryAPI("/salesforce/districts");
  return res;
}

/**
 * get the list of classification
 *
 */

export async function getClassificationData() {
  const res = await queryAPI("/salesforce/classification");
  return res;
}

/**
 * get the list of Ngos by name
 *
 */
export async function getNgosByName(ngoName, page) {
  const response = await queryAPI(
    "/salesforce/ngo/name/" + ngoName + "?page=" + page,
    "get"
  );

  return response;
}

export async function getNgosByParams(params) {
  const response = await queryAPI("/salesforce/ngo", "get", {}, params);
  return response;
}

/**
 * get the list of employees-lvl
 *
 */

export async function getEmployeesLvl() {
  const res = await queryAPI("/salesforce/employees-lvl");
  return res;
}

/**
 * get the list of yearlycycle-lvl
 *
 */

export async function getYearlycycleLvl() {
  const res = await queryAPI("/salesforce/yearlycycle-lvl");
  return res;
}

export async function getFavNgosFromSrvr(favList) {
  const dataToSend = favList.join("&");

  const response = await queryAPI("/salesforce/ngos/favorite/" + dataToSend);
  return response;
}

export async function getFavsNgos(user) {
  const firestore = getFirestore();
  const collection = "favoriteNgos";
  const userId = user;

  const path = `${collection}/${userId}`;
  const docRef = doc(firestore, path);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data().favoriteNGOs;
  } else {
    console.log("No such document!");
    return [];
  }
}

export async function addFavNgo(user, ngos) {
  const firestore = getFirestore();
  const collection = "favoriteNgos";
  const userId = user;
  const path = `${collection}/${userId}`;
  const data = doc(firestore, path);
  const docData = {
    favoriteNGOs: ngos,
  };
  await setDoc(data, docData);
}
